import {h, Component} from 'preact';
import cx from 'classnames';

const LOADING_LABEL = upi.i18n.getTextFromKey( 'lbl-loading', 'Loading' );

export default class Spinner extends Component {
    render () {

        const {message, className, reverse, padding = 4, ...restProps} = this.props;

        const wrapperClasses = cx(
            'flex items-center leading-collapse',
            `p-${padding}`,
            className
        );
        const loaderClasses = cx(
            'mr-2 w-6 h-6',
            reverse ? 'spinner-reverse' : 'spinner'
        );

        return (
            <div className={wrapperClasses} {...restProps}>
                <span className={loaderClasses}/>
                {message}...
            </div>
        );
    }
}

Spinner.displayName = 'Spinner';

Spinner.defaultProps = {
    message: LOADING_LABEL
};
